import React from 'react';
import { useFormikContext } from 'formik';

import { Input } from '../../Form/Input/Input';
import { CategoriesSelect } from '../../Form/CategoriesSelect/CategoriesSelect';
import { TagsSelect } from '../../Form/TagsSelect/TagsSelect';

import type { FC } from 'react';
import type { PageInput } from '../../../types';

type Props = { isNew?: boolean };

export const PageTaxonomy: FC<Props> = ({ isNew = false }) => {
  const { values } = useFormikContext<PageInput>();

  if (!values) {
    return null;
  }

  const { type } = values;

  switch (type) {
    case 'custom':
      return <Input label="Slug" name="slug" disabled={!isNew} />;
    case 'category':
      return (
        <CategoriesSelect label="Category" name="entityId" disabled={!isNew} />
      );
    case 'tag':
      return <TagsSelect label="Tag" name="entityId" disabled={!isNew} />;
    default:
      return null;
  }
};
